import React from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './app/store';
import reportWebVitals from './reportWebVitals';
import ThemeContext from './midleware/ThemeContext';
import posthog, { initPostHog } from './analytics/posthog';
import { HelmetProvider } from 'react-helmet-async';

initPostHog();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter
    future={{
    v7_startTransition: true,
      v7_relativeSplatPath: true,
  }}>
      <HelmetProvider>
        <ThemeContext/>
      </HelmetProvider>
    </BrowserRouter>
  </Provider>
   </React.StrictMode>,
);

// Forward Core Web Vitals to PostHog so they appear alongside session replays
// and can be used in custom insights. Each metric is a separate capture event.
// posthog is already initialised above — no dynamic import needed.
reportWebVitals(({ name, value, id, delta, rating }) => {
  posthog.capture('web_vital', { name, value, id, delta, rating });
});
